<template>
    <div>
        <BasicDialog @close="emitClose">
            <v-row>




                <v-col cols="12" class="d-flex flex-row justify-center align-center">
                    <logo-background></logo-background>
                    <div style="position: absolute;" class="d-flex flex-row justify-center align-center">
                        <img :src="AppConfigs.staticImages.FACEBOOK">
                        <img :src="AppConfigs.staticImages.SHAREICON" v-if="isAvailable"
                            style="position: absolute; top: -10%; left: 10%;">
                        <img :src="AppConfigs.staticImages.PRIMARYCHECK" v-if="!isAvailable"
                            style="position: absolute; top: -60%; left: -45%;">
                    </div>
                </v-col>




                <v-col cols="12" class="d-flex flex-row justify-center texrt-center text-h5 font-weight-bold">
                    Share on Facebook
                </v-col>




                <v-col cols="12" class="d-flex flex-row justify-center text-body-2">
                    Share us on your Facebook and earn {{ coinsForSharingOnFacebook }} coins
                </v-col>




                <v-col cols="12" class="d-flex flex-row justify-center">
                    <v-btn rounded="pill" :disabled="!isAvailable"
                        class="  button--primary text-h6 font-weight-medium pl-6 pr-6 py-6 d-flex"
                        @click="shareOnFacebook">
                        <template v-slot:prepend>
                            <v-icon>
                                <coin-big></coin-big>
                            </v-icon>
                        </template>
                        Share now
                    </v-btn>
                </v-col>




            </v-row>
        </BasicDialog>
    </div>
</template>



<script>

import { AppConfigs } from "@/app.configs";
import { UserActivityStore } from '@/store/UserActivityStore';
import { ref, watchEffect, defineComponent, computed, inject, provide } from 'vue';

import CoinBig from "@/icons/CoinBig.vue";
import LogoBackground from "@/icons/LogoBackground.vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";

export default defineComponent({
    name: 'ShareOnFacebookDialog',
    components: {
        CoinBig,
        BasicDialog,
        LogoBackground,
    },
    setup(props, { emit }) {
        const isDialogOpen = ref(props.dialogOpen);
        let openDialog = inject('inHouseTaskOpenDialog');
        provide('openDialog', openDialog);
        const inHouseTasksStore = UserActivityStore();
        const coinsForSharingOnFacebook = computed(() => inHouseTasksStore.selectedInHouseTask.coins_amount);
        const isAvailable = computed(() => inHouseTasksStore.selectedInHouseTask.availability_info.is_available);

        // Sync the reactive isDialogOpen with the prop
        watchEffect(() => {
            isDialogOpen.value = props.dialogOpen;
        });

        // Hardcoded share URL
        const shareUrl = 'https://webappdev.bountyhunterapp.co';

        function emitClose() {
            emit("close");
        }

        function shareOnFacebook() {
            const encodedUrl = encodeURIComponent(shareUrl);
            const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
            window.open(facebookShareUrl, '_blank');
            inHouseTasksStore.redeemCoinsForSelectedInHouseTask();
        }

        // Access to other composables can be done here if needed

        return {
            emitClose,
            AppConfigs,
            isAvailable,
            isDialogOpen,
            shareOnFacebook,
            inHouseTasksStore,
            coinsForSharingOnFacebook,
        };
    },
});
</script>